import { render, staticRenderFns } from "./SpeciesFacts.vue?vue&type=template&id=3e20d990&scoped=true&"
import script from "./SpeciesFacts.vue?vue&type=script&lang=js&"
export * from "./SpeciesFacts.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesFacts.vue?vue&type=style&index=0&id=3e20d990&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20d990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
